import { Row, TableCell, Text, Thumbnail } from '@amzn/meridian';
import type { UsersPermissionTableRowUserNameCellFragment } from 'generated/graphql';
import type { FC } from 'react';

export type UsersPermissionTableNameCellProps = {
  user: UsersPermissionTableRowUserNameCellFragment;
};

export const UsersPermissionTableNameCell: FC<UsersPermissionTableNameCellProps> = ({ user }) => {
  const thumbnailSource = `https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=${user.alias}`;
  return (
    <TableCell>
      <Row>
        <Thumbnail size="small" source={thumbnailSource} type="circular" />
        <Text>{`${user.firstName} ${user.lastName}`}</Text>
      </Row>
    </TableCell>
  );
};
